import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Printer, ArrowLeft } from "lucide-react";
import { api, errMsg, fmtDate } from "../lib/api";
import { useAuth, homeFor } from "../lib/auth";
import { useSeo } from "../lib/site";
import { EmptyState, Spinner } from "../components/common";

export default function Certificate() {
  const { id } = useParams();
  const { user } = useAuth();
  const [c, setC] = useState(null);
  const [err, setErr] = useState("");
  useSeo({ title: "Certificate of Completion", noindex: true });
  useEffect(() => { api.get(`/certificates/${id}`).then((r) => setC(r.data)).catch((e) => setErr(errMsg(e))); }, [id]);
  if (err) return <div className="container-x py-20"><EmptyState>{err}</EmptyState></div>;
  if (!c) return <Spinner />;
  return (
    <div className="min-h-screen bg-slate-100 py-8 print:bg-white print:py-0">
      <style>{"@media print { @page { size: landscape; margin: 0.4in; } .no-print { display: none !important; } }"}</style>
      <div className="no-print mx-auto mb-6 flex max-w-5xl justify-between px-4">
        <Link to={homeFor(user)} className="btn-outline btn-sm" data-testid="certificate-back"><ArrowLeft className="h-4 w-4" />Back to portal</Link>
        <button onClick={() => window.print()} className="btn-primary btn-sm" data-testid="certificate-print"><Printer className="h-4 w-4" />Print / Save as PDF</button>
      </div>
      <div className="mx-auto max-w-5xl bg-white p-3 shadow-xl print:shadow-none" data-testid="certificate">
        <div className="border-[10px] border-double border-slate-900 p-10 text-center sm:p-14">
          {c.logo_url && <img src={c.logo_url} alt={c.org_name} className="mx-auto h-20 w-auto object-contain" />}
          <p className="mt-6 text-xs font-bold uppercase tracking-[0.35em] text-red-600">Certificate of Completion</p>
          <p className="mt-6 text-sm text-slate-500">This certifies that</p>
          <h1 className="mt-2 font-heading text-4xl font-extrabold text-slate-900 sm:text-5xl" data-testid="certificate-student">{c.student_name}</h1>
          <div className="mx-auto mt-3 h-0.5 w-2/3 bg-red-600" />
          <p className="mt-6 text-sm text-slate-500">has successfully completed the</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-slate-900 sm:text-3xl" data-testid="certificate-program">{c.program_name} Program</h2>
          {c.hours && <p className="mx-auto mt-3 max-w-2xl text-xs text-slate-500">{c.hours}</p>}
          <div className="mt-12 grid grid-cols-3 items-end gap-6 text-xs text-slate-600">
            <div><p className="font-semibold text-slate-900">{fmtDate(c.completed_at)}</p><div className="mt-1 border-t border-slate-400 pt-1">Date of completion</div></div>
            <div><p className="font-mono font-semibold text-slate-900" data-testid="certificate-number">{c.certificate_number}</p><div className="mt-1 border-t border-slate-400 pt-1">Certificate number</div></div>
            <div><p className="h-4" /><div className="mt-1 border-t border-slate-400 pt-1">Program Coordinator</div></div>
          </div>
          <p className="mt-10 text-[11px] text-slate-400">{c.org_name} · {c.address}. This certificate confirms program completion. Industry certification exams are administered separately by the certifying organization.</p>
        </div>
      </div>
    </div>
  );
}
